<template>
	<view></view>
</template>

<script>
	export default {
		onLoad(options) {
			uni.redirectTo('/shop/pages/store-home/store-home')
		}
	}
</script>

<style lang="scss" scoped></style>